/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { Flex } from '@components/common/primitives';

export const LoadingContainer = styled(Flex)`
  min-height: 40px;
`;
